var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEc30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.14,9.07s-.01-.03-.02-.04-.03-.01-.04-.02c-2.55-2.54-6.07-4.11-9.95-4.11C6.34,4.89,0,11.23,0,19.02c0,3.77,1.47,7.32,4.14,9.99.17.17.4.26.63.26s.45-.09.63-.26l2.07-2.07c.35-.35.35-.91,0-1.26s-.91-.35-1.26,0l-1.41,1.41c-1.75-2.02-2.79-4.51-2.98-7.18h2.26c.49,0,.89-.4.89-.89s-.4-.89-.89-.89H1.82c.2-2.74,1.28-5.22,2.98-7.18l6.1,6.1c-.35.58-.57,1.25-.57,1.97,0,2.09,1.7,3.79,3.79,3.79s3.79-1.7,3.79-3.79-1.7-3.79-3.79-3.79c-.72,0-1.39.21-1.97.57l-6.1-6.1c1.96-1.69,4.44-2.78,7.18-2.98v2.26c0,.49.4.89.89.89s.89-.4.89-.89v-2.26c2.74.2,5.22,1.28,7.18,2.98l-1.34,1.34c-.35.35-.35.91,0,1.26.17.17.4.26.63.26s.45-.09.63-.26l1.34-1.34c1.69,1.96,2.78,4.44,2.98,7.18h-2.26c-.49,0-.89.4-.89.89s.4.89.89.89h2.26c-.19,2.67-1.22,5.16-2.97,7.18l-1.41-1.41c-.35-.35-.91-.35-1.26,0s-.35.91,0,1.26l2.07,2.07c.17.17.4.26.63.26s.45-.09.63-.26c2.67-2.67,4.14-6.21,4.14-9.99s-1.57-7.39-4.11-9.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30,3.44c0-1.49-1.21-2.7-2.7-2.7s-2.7,1.21-2.7,2.7c0,1.2.79,2.21,1.88,2.56v3.08c0,.45.37.82.82.82s.82-.37.82-.82v-3.08c1.09-.35,1.88-1.36,1.88-2.56Zm-2.7,1.05c-.58,0-1.05-.47-1.05-1.05s.47-1.05,1.05-1.05,1.05.47,1.05,1.05-.47,1.05-1.05,1.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc30);
export default __webpack_public_path__ + "static/media/EC30.a56a2f95e93386fc45d61c6e3f22a990.svg";
export { ForwardRef as ReactComponent };